<template>
  <div>
    <router-view />
    <global-chat-notifier />
  </div>
</template>

<script>
  import GlobalChatNotifier from '@/components/GlobalChatNotifier'

  export default {
    name: 'App',
    components: {
      GlobalChatNotifier,
    },
  }
</script>

<style>
* {
  font-family: 'Inter', sans-serif !important;
}

/* Restaurar fontes de ícones - deve vir DEPOIS da regra universal */
i.fas, span.fas,
i.fa, span.fa {
  font-family: "Font Awesome 6 Free" !important;
  font-weight: 900 !important;
}


.v-application {
  font-family: 'Inter', sans-serif !important;
}

.v-application .text-h1,
.v-application .text-h2,
.v-application .text-h3,
.v-application .text-h4,
.v-application .text-h5,
.v-application .text-h6,
.v-application .headline,
.v-application .title,
.v-application .subtitle-1,
.v-application .subtitle-2,
.v-application .body-1,
.v-application .body-2,
.v-application .caption,
.v-application .overline {
  font-family: 'Inter', sans-serif !important;
}
</style>
